export default "__VITE_ASSET__BYbWN_5T__"